// contains configuration options used to render the Chart.js charts for a selected city or urban area.

import { chartOnHover } from "../constants"

export const chartOptions = (data: any, labels: any) => {

    return ({
        maintainAspectRatio: false,
  indexAxis: "y" as const,
  scales: {
    y: {
      ticks: {
        font: {
          size: 11,
        },
        callback: (e: any) => {
          // Custom callback function to wrap labels to a maximum line length of 15 characters
          // Access the label at the correct index
          const label = labels[e]
          // If the label is less than or equal to 15 characters in length, return that label
          if (label.length <= 15) {
            return label
          } else {
            let startIndex = 0
            const labelArray = []
            // Iterate over the label string and add substrings of 15 characters or less, separated by space characters
            while (startIndex < label.length) {
              let endIndex = startIndex + 15;
              if (endIndex + 1 >= label.length) {
                labelArray.push(label.substring(startIndex).trim())
              } else {
                while (endIndex > startIndex && label[endIndex] !== ' ') {
                  endIndex--;
                }
                if (endIndex === startIndex) {
                  endIndex = startIndex + 15
                }
                labelArray.push(label.substring(startIndex, endIndex).trim());
              }
              startIndex = endIndex + 1;
            }
            return labelArray
          }
        }
      },
    },

    x: {
      ticks: {
        font: {
          size: 11,
        },
      },
      min: 0,
      max: 100
    },
  },
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  redraw: true,
  plugins: {
    title: {
      display: false,
      text: "Chart.js Horizontal Bar Chart",
    },
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function(context: any) {
         let lab = 'label';
        chartOnHover.forEach((demo: any) => {
            if(demo.displayName === context.label) {
                lab = data[demo.value].toLocaleString();   
            }
        })
        return ' ' + lab;  
        }
      }
    },
    datalabels: {
      display: true,
      color: "black",
      formatter: function (val: any) {
        return "   " + val.toLocaleString("en-US") + '%';
      },
    },
  },
    }
    )

}